import { render, staticRenderFns } from "./NumberCard.vue?vue&type=template&id=128ea3e9&scoped=true&"
import script from "./NumberCard.vue?vue&type=script&lang=ts&"
export * from "./NumberCard.vue?vue&type=script&lang=ts&"
import style0 from "./NumberCard.vue?vue&type=style&index=0&id=128ea3e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128ea3e9",
  null
  
)

export default component.exports